import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import { selectAppPersistTranslationsHash, useAppPersistActions } from '@store/useAppStorePersist';

export const translationsListKey = () => ['translationsList'];
export const translationsListFn = () => apiClient.get(`${APP_API_URL}translations/get-list`);

export const useTranslationsListQuery = () => {
  const { setAppPersistI18n, setAppPersistTranslationsHash } = useAppPersistActions();
  const translationsHash = selectAppPersistTranslationsHash();

  return useQuery({
    queryKey: translationsListKey(),
    queryFn: translationsListFn,
    onSuccess: ({ data }) => {
      const { translationsHash: newTranslationHash, translations } = data;
      if (newTranslationHash !== translationsHash) {
        setAppPersistTranslationsHash(newTranslationHash);
        setAppPersistI18n(translations);
      }
    },
  });
};
